const totalSummary = (value, flag, values) => {
    return values[`analisa_${value}`].filter(val => val.flag === flag).reduce((val, data) => {
        const harga = value === 'alat_mesin' ? (data.biaya_penyusutan_per_jam ? parseInt(data.biaya_penyusutan_per_jam) : 0) : (data[`harga_satuan_${value}`] ? parseInt(data[`harga_satuan_${value}`]) : 0)
        const qty_produksi = parseInt(data.qty_produksi) || 0
        return val + (harga * qty_produksi)
    }, 0)
}

export default totalSummary